import request from "@/util/request";
import util from "@/util/util";
class bindKdy {
  //绑定业务员通过姓名
  bindingYwyByName(self,data){
    return new Promise((resolve, reject) => {
      request
        .post(self, {
          action: "kdyserver.account.bindingYwyByName",
          data:data
        })
        .then(res => {
          if (~~res.body.code === 200) {
              resolve({
                success: true,
                data: res.body
              });
          }else {
            resolve({
              success: false,
              data: {
                code: res.body.code,
                error: res.body.message || res.body.remark
              }
            });
            self.$message.error(res.body.message || res.body.remark);
          }
        });
    });
  }
  // 绑定业务员通过验证码第一步
  bindingYwyBySmsCodeAccount(self,data){
    return new Promise((resolve, reject) => {
    request
        .post(self, {
        action: "kdyserver.account.bindingYwyBySmsCodeAccount",
        data: data
        })
        .then(res => {
        if (res.success) {
            if (~~res.body.code === 200) {
            resolve({
                success: true,
                data: res.body
            });
            } else {
            resolve({
                success: false,
                data: {
                code: res.body.code,
                error: res.body.message || res.body.remark
                }
            });
            self.$message.error(res.body.message || res.body.remark);
            }
        }
        });
    });
  }
  // 绑定业务员通过验证码
  bindingYwyBySmsCode(self,data){
    return new Promise((resolve, reject) => {
    request
        .post(self, {
        action: "kdyserver.account.bindingYwyBySmsCode",
        data: data
        })
        .then(res => {
        if (res.success) {
            if (~~res.body.code === 200) {
            resolve({
                success: true,
                data: res.body
            });
            } else {
            resolve({
                success: false,
                data: {
                code: res.body.code,
                error: res.body.message || res.body.remark
                }
            });
            self.$message.error(res.body.message || res.body.remark);
            }
        }
        });
    });
  }
  sendBindingSmsCode(self,data){
    return new Promise((resolve, reject) => {
    request
        .post(self, {
        action: "kdyserver.account.sendBindingSmsCode",
        data: data
        })
        .then(res => {
        if (res.success) {
            if (~~res.body.code === 200) {
            resolve({
                success: true,
                data: res.body.data
            });
            } else {
            resolve({
                success: false,
                data: {
                code: res.body.code,
                error: res.body.message || res.body.remark
                }
            });
            self.$message.error(res.body.message || res.body.remark);
            }
        }
        });
    });
  }
  //提交资料
  updateAccountInfo(self,data){
    return new Promise((resolve, reject) => {
      request
          .post(self, {
          action: " kdyserver.account.updateAccountInfo",
          data: data
          })
          .then(res => {
          if (res.success) {
              if (~~res.body.code === 200) {
              resolve({
                  success: true,
                  data: res.body.data
              });
              } else {
              resolve({
                  success: false,
                  data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                  }
              });
              self.$message.error(res.body.message || res.body.remark);
              }
          }
          });
      });
  }
  // 发送短信
  sendmobilemsg(self,phone){
    return new Promise((resolve, reject) => {
      request
          .post(self, {
          action: "kdyserver.account.sendmobilemsg",
          data: {
            account_id: util.getCookie("account_id"),
            phone:phone
          }
          })
          .then(res => {
          if (res.success) {
              if (~~res.body.code === 200) {
              resolve({
                  success: true,
                  data: res.body.data
              });
              } else {
              resolve({
                  success: false,
                  data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                  }
              });
              self.$message.error(res.body.message || res.body.remark);
              }
          }
          });
      });
  }
  // 实名验证
  checkRealName(self){
    return new Promise((resolve, reject) => {
      request
          .post(self, {
          action: "kdyserver.realName.checking",
          data: {
            account_id: util.getCookie("account_id"),
          }
          })
          .then(res => {
          if (res.success) {
              if (~~res.body.code === 200) {
              resolve({
                  success: true,
                  data: true
              });
              } else {
              resolve({
                  success: false,
                  data: false,
                  code: res.body.code
              });
              // self.$message.error(res.body.message || res.body.remark);
              }
          }
          });
      });
  }
  // 获取上次申请信息
  queryAccountInfo(self){
    return new Promise((resolve, reject) => {
      request
          .post(self, {
          action: "kdyserver.account.queryAccountInfo",
          data: {account_id: util.getCookie("account_id")}
          })
          .then(res => {
          if (res.success) {
              if (~~res.body.code === 200) {
              resolve({
                  success: true,
                  data: true
              });
              } else {
              resolve({
                  success: false,
                  data:false
              });
              // self.$message.error(res.body.message || res.body.remark);
              }
          }
          });
      });
  }
  //添加网点电子面单账号
  bindsItemail(self,data){
    return new Promise((resolve, reject) => {
      request
          .post(self, {
          action: "kdyserver.mail.bindsitemail",
          data: data
          })
          .then(res => {
          if (res.success) {
              if (~~res.body.code === 200) {
              resolve({
                  success: true,
                  data: res.body.data
              });
              } else {
              resolve({
                  success: false,
                  data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                  }
              });
              self.$message.error(res.body.message || res.body.remark);
              }
          }
          });
      });
  }
  // 删除电子面单账号
  delMailauth(self,data){
    return new Promise((resolve, reject) => {
      request.post(self, {
          action: "kdyserver.mail.unbindmailauth",
          data: data
          })
          .then(res => {
          if (res.success) {
              if (~~res.body.code === 200) {
              resolve({
                  success: true,
                  data: res.body.data
              });
              } else {
              resolve({
                  success: false,
                  data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                  }
              });
              self.$message.error(res.body.message || res.body.remark);
              }
          }
          });
      });
  }
  // 查看网点电子面单账号
  lookMailinfo(self,data){
    return new Promise((resolve, reject) => {
      request
          .post(self, {
          action: "kdyserver.mail.getsitemailinfo",
          data: data
          })
          .then(res => {
          if (res.success) {
              if (~~res.body.code === 200) {
              resolve({
                  success: true,
                  data: res.body.data
              });
              } else {
              resolve({
                  success: false,
                  data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                  }
              });
              self.$message.error(res.body.message || res.body.remark);
              }
          }
          });
      });
  }
  //查看协议快递员的电子面单
  queryMailAuthInfo(self,data){
    return new Promise((resolve, reject) => {
      request
          .post(self, {
          action: "kdyserver.mail.queryMailAuthInfo",
          data: data
          })
          .then(res => {
          if (res.success) {
              if (~~res.body.code === 200) {
              resolve({
                  success: true,
                  data: res.body.data
              });
              } else {
              resolve({
                  success: false,
                  data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                  }
              });
              self.$message.error(res.body.message || res.body.remark);
              }
          }
          });
      });
  }
  //获取保价保费值
  queryInsured(self,data){
    return new Promise((resolve, reject) => {
      request
          .post(self, {
          action: "kdyserver.order.query.insured",
          data: data
          })
          .then(res => {
          if (res.success) {
              if (~~res.body.code === 200) {
              resolve({
                  success: true,
                  data: res.body.data
              });
              } else {
              resolve({
                  success: false,
                  data: {
                  code: res.body.code,
                  error: res.body.message || res.body.remark
                  }
              });
              self.$message.error(res.body.message || res.body.remark);
              }
          }
          });
      });
  }
  }
  export default new bindKdy()